export default function diffContextDisplayReducer(state = [], action) {
	switch (action.type) {
	case 'UPDATE_DIFF_CONTEXT_DISPLAY' :
		return action.showDiffContext;

	default:
		return state;
	}
}
